
import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
import { ThanksPage } from '../../pages/thanks/thanks';
import { RidePage } from '../../pages/ride/ride';

import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker,
  Environment
} from '@ionic-native/google-maps';

declare var google;

@Component({
  selector: 'page-detail',
  templateUrl: 'detail.html'
})
export class DetailPage {
  loading: Loading;
  startbtn: boolean = true;
  drivestartbtn:boolean=true;
  dropbtn:boolean=true;
  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
  
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  items2;
  items3;
 dataget;
routeResponse;
 //  @ViewChild(Tabs) tabs;
 

  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams) {
    
    this.items = navParams.get('data');
    
  
  }
  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
        //  this.nav.remove(index);
          // this.navCtrl.rootNav.setRoot(LoginsignupPage);  
  
           // this.viewCtrl.dismiss();
         //  this.appCtrl.getRootNav().setRoot(LoginPage);
           //this.navCtrl.setRoot(LoginsignupPage);  
          // localStorage.clear();
          // this.nav.setRoot(LoginPage);
          }
        }
      ]
    });
    alert.present();
  }
  accept(orderid){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
  let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"status":2}
  let data_parameters=acceptride;
  let method='driver_order_accept_and_cancel.php';
  
  this.authService.postData(data_parameters,method).then((result) => {
    this.loading.present();
    this.obj = result;
    console.log(this.obj);
    
   if(this.obj.status=='true'){
    this.loading.dismiss();
     this.navCtrl.push(RidePage,{ data:this.items}) 
     //this.navCtrl.push(ListPage,{ data:this.items}) 
   // this.All();
    }
   
   else{
    this.loading.dismiss();
  //  loading.dismiss();
    //alert(this.obj.message);
    }
    
    }, (err) => {
      // Error log
  });
}
  waitlocation(orderid){
     //alert//
     let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });
         
            
            let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":3}
            let data_parameters=acceptride;
            let method='ride_status.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
              this.loading.present();
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
              this.loading.dismiss();
             this.startbtn=false;
              }
             
             else{

            this.loading.dismiss();
              //alert(this.obj.message);
              }
              
              }, (err) => {
                // Error log
            });
          }
        }
      ]
    });
    alert.present();
    //end//
  }
  
  startdrive(orderid){
    //alert//
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });
          
            let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":2}
            let data_parameters=acceptride;
            let method='ride_status.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
              this.loading.present();
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
            //  this.startbtn=false;
            //  this.startbtn=false;
           // 
           this.loading.dismiss();
             this.drivestartbtn=false;
             this.dropbtn=true;
             this.items.ridestatus=2;
              }
             
             else{
              this.loading.dismiss();
             // this.loading.dismissAll();
              //alert(this.obj.message);
              }
              
              }, (err) => {
                // Error log
            });
          }
        }
      ]
    });
    alert.present();
    //end//
  }

  droplocation(orderid){
//alert//
  let alert = this.alertCtrl.create({
  title: '',
  message: 'Sind Sie sicher ?',
  buttons: [
    {
      text: 'Abbruch',
      role: 'cancel',
      handler: () => {
        //console.log('Cancel clicked');
      }
    },
    {
      text: 'OK',
      handler: () => {
        this.loading = this.loadingCtrl.create({
          content: '',
          });
       
        let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":4}
        let data_parameters=acceptride;
        let method='ride_status.php';
      
        this.authService.postData(data_parameters,method).then((result) => {
          this.loading.present();
          this.obj = result;
          console.log(this.obj);
          
         if(this.obj.status=='true'){
          this.loading.dismiss();
          this.items.ridestatus=2;
         this.dropbtn=false;
         this.navCtrl.setRoot(ThanksPage)
       
          }
         
         else{
          this.loading.dismiss();
          //alert(this.obj.message);
          }
          
          }, (err) => {
            // Error log
        });
      }
    }
  ]
});
alert.present();
  }

  startride(orderid){

    //alert//
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });
           
            
            let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":1}
            let data_parameters=acceptride;
            let method='ride_status.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
              this.loading.present();
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
              this.drivestartbtn=true;
             this.startbtn=false;
             this.items.ridestatus=1;
             this.loading.dismiss();
              }
             
             else{
              this.loading.dismiss();
              //alert(this.obj.message);
              }
              
              }, (err) => {
                // Error log
            });
          }
        }
      ]
    });
    alert.present();
    //end//
  }
  
  ionViewDidLoad() {

  
    console.log(this.items);


}
 

 
    
}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts